import { createContext, useContext, useEffect, useState } from "react";
import jwt_decode from "jwt-decode";

export const AuthContext = createContext();

export default function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tokenExpired, setTokenExpired] = useState(false);

    const checkToken = () => {
        const token = localStorage.getItem("accessToken");
        if (!token) return true;
        try {
            const decoded = jwt_decode(token);
            return decoded.exp * 1000 < Date.now();
        } catch {
            return true;
        }
    };

    // LOGIN method: update state + localStorage
    const login = (resData) => {
        const decodeToken = resData.token ? jwt_decode(resData.token) : null;
        if (!decodeToken) return;

        localStorage.setItem("accessToken", resData.token);
        localStorage.setItem("user", decodeToken.name);
        localStorage.setItem("designation", decodeToken.designation);
        localStorage.setItem("placeId", decodeToken.place);
        localStorage.setItem("branch", decodeToken.branch);
        localStorage.setItem("branchId", decodeToken.branchId);
        localStorage.setItem("permissions", JSON.stringify(resData.permissions));

        // update context state immediately
        setUser(decodeToken.name);
        setPermissions(resData.permissions);
        setTokenExpired(false);
    };

    // LOGOUT method
    const logout = () => {
        localStorage.clear();
        setUser(null);
        setPermissions([]);
        setTokenExpired(true);
    };

    useEffect(() => {
        const token = localStorage.getItem("accessToken");

        if (!token) {
            setLoading(false);
            return;
        }

        const expired = checkToken();
        setTokenExpired(expired);

        if (expired) {
            logout();
            setLoading(false);
            return;
        }

        setUser(localStorage.getItem("user"));

        const savedPermissions = localStorage.getItem("permissions");
        if (savedPermissions) {
            try {
                setPermissions(JSON.parse(savedPermissions));
            } catch {
                console.error("Invalid permissions JSON:", savedPermissions);
                setPermissions([]);
            }
        }

        setLoading(false);
    }, []);

    return (
        <AuthContext.Provider
            value={{
                user,
                permissions,
                loading,
                tokenExpired,
                login,   // <-- expose login method
                logout,  // <-- expose logout method
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
